import { render, staticRenderFns } from "./filters-tags.vue?vue&type=template&id=c7783564"
import script from "./filters-tags.vue?vue&type=script&lang=js"
export * from "./filters-tags.vue?vue&type=script&lang=js"
import style0 from "./filters-tags.vue?vue&type=style&index=0&id=c7783564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports